import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useTheme } from "../../services/ThemeContext";

type NotFoundPageProps = {
  errorcode?: number | null;
  message?: string;
  goHome?: boolean;
};

const NotFoundPage: React.FC<NotFoundPageProps> = ({
  errorcode,
  message,
  goHome
}) => {
  const nav = useNavigate();
  const { t } = useTranslation();
  const [pageHeight, setPageHeight] = React.useState(0);
  const { theme } = useTheme();

  useEffect(() => {
    const navbar = document.querySelector(".navbar");
    const footer = document.querySelector(".footer");
    // height of navbar and footer
    const navbarHeight = navbar ? navbar.clientHeight : 0;
    const footerHeight = footer ? footer.clientHeight : 0;
    // get footer margin
    const footerMargin = footer
      ? parseInt(window.getComputedStyle(footer).marginTop)
      : 0;
    console.log(navbarHeight, footerHeight, footerMargin);
    console.log(navbarHeight + footerHeight + footerMargin);
    setPageHeight(navbarHeight + footerHeight + footerMargin);
  }, []);

  return (
    <div
      className={`container m-auto flex items-center justify-center text-center ${theme === "dark" ? "text-white" : "text-black"}`}
      style={{ minHeight: `calc(100svh - ${pageHeight}px)` }}
    >
      <div>
        {errorcode !== null && (
          <h1 className="h1 mt-5 text-6xl">{errorcode ? errorcode : 404}</h1>
        )}

        <p className="text-3xl">{message ? message : t("Page not found")}</p>
        {goHome && (
          <button
            className="btn btn-primary btn-sm mt-3 rounded-lg border-none"
            onClick={() => {
              nav("/");
            }}
          >
            {t("Go Home")}
          </button>
        )}
      </div>
    </div>
  );
};

export default NotFoundPage;
